import { FC } from 'react';

import { SelectedAktor } from '../../utils/types';
import useLocalStorage from '../useLocalStorage';

import AppContext, { AppContextValues } from './context';

const AppDataProvider: FC = ({ children }) => {
  const [
    selectedAktor,
    setSelectedAktor,
  ] = useLocalStorage<SelectedAktor | null>('user');
  const values: AppContextValues = {
    setSelectedAktor,
    selectedAktor,
  };
  return <AppContext.Provider value={values}>{children}</AppContext.Provider>;
};

export default AppDataProvider;
